/* PlantSwitch theme · Shannon Cain, 2026
   "Switch" buttons. Every call to action gets the same build: the label, and a round knob on the right that
   carries the arrow (the same knob as the PlantSwitch switch in the footer). On hover the knob floods the whole
   button, the label rolls up letter by letter and the arrow is swapped for a fresh one. Colors are read from the
   button's own styles, so every existing variant (green, ink, white, outline, ghost) keeps its look at rest.
   Screen readers get the plain label; reduced motion keeps the flood but drops the roll.
   Also: the CompostZero seal speeds its ring up on hover instead of tilting. */
(function () {
  var d = document;
  var SEL = '.ps-btn, .ps-buy__go, .ps-sb__all, .ps-br__btn, .ps-hdr-cta, .ps-cs__field button, .ps-ap__submit, [data-ps-k]';
  var ARW = /[→↓↗↑←]/g;
  var PATHS = {
    right: 'M4 12h14M13 6l6 6-6 6',
    down: 'M12 4v14M6 13l6 6 6-6',
    up: 'M12 20V6M6 11l6-6 6 6',
    out: 'M7 17L17 7M9 7h8v8'
  };
  function svg(dir, cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + PATHS[dir] + '"/></svg>';
  }
  function rgb(s) { var m = s && s.match(/[\d.]+/g); return m ? m.map(Number) : null; }
  function opaque(c) { return c && (c.length < 4 || c[3] > 0.5); }
  function light(c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255 > 0.6; }
  function isHidden(el) { return /visually-hidden|ps-vh|sr-only/.test(el.className || '') || el.hidden; }

  function build(el) {
    if (el.__k || el.closest('.ps-k')) return;
    if (el.querySelector('img, video, .ps-k__t')) return;
    var clone = el.cloneNode(true);
    clone.querySelectorAll('*').forEach(function (c) { if (isHidden(c) || c.matches('.ps-arw, i, svg')) c.remove(); });
    var raw = el.textContent;
    var label = clone.textContent.replace(ARW, '').replace(/\s+/g, ' ').trim();
    if (!label || label.length > 40) return;
    el.__k = 1;
    var dir = /↓/.test(raw) ? 'down' : /↗/.test(raw) ? 'out' : /↑/.test(raw) ? 'up' : 'right';
    if (el.dataset.psK) dir = el.dataset.psK in PATHS ? el.dataset.psK : dir;

    var cs = getComputedStyle(el), bg = rgb(cs.backgroundColor), fg = rgb(cs.color);
    var inv = opaque(bg) ? cs.backgroundColor : (light(fg) ? '#14231C' : '#fff');
    el.style.setProperty('--k-fg', cs.color);
    el.style.setProperty('--k-inv', inv);

    var keep = [];
    Array.prototype.slice.call(el.childNodes).forEach(function (n) { if (n.nodeType === 1 && isHidden(n)) keep.push(n); n.remove(); });
    var chars = label.split('').map(function (ch, i) {
      return '<span style="--i:' + i + '">' + (ch === ' ' ? '&nbsp;' : ch.replace(/&/g, '&amp;').replace(/</g, '&lt;')) + '</span>';
    }).join('');
    el.insertAdjacentHTML('beforeend',
      '<span class="ps-k__fill" aria-hidden="true"></span>' +
      '<span class="ps-k__t" aria-hidden="true"><span class="ps-k__r">' + chars + '</span><span class="ps-k__r ps-k__r2">' + chars + '</span></span>' +
      '<span class="ps-k__k" aria-hidden="true">' + svg(dir, 'ps-k__a1') + svg(dir, 'ps-k__a2') + '</span>' +
      '<span class="ps-vh">' + label.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>');
    keep.forEach(function (n) { el.appendChild(n); });
    el.classList.add('ps-k', 'ps-k--' + dir);
  }

  function seals() {
    d.querySelectorAll('.ps-hx__seal, .ps-pp__seal').forEach(function (a) {
      if (a.__s) return; a.__s = 1;
      var spin = a.querySelector('.ps-cz__spin'); if (!spin || !spin.getAnimations) return;
      function rate(to) {
        spin.getAnimations().forEach(function (an) {
          if (window.gsap) window.gsap.to(an, { playbackRate: to, duration: 0.8, ease: 'power2.out' }); else an.playbackRate = to;
        });
      }
      a.addEventListener('pointerenter', function () { rate(7); });
      a.addEventListener('pointerleave', function () { rate(1); });
    });
  }

  function scan() { d.querySelectorAll(SEL).forEach(build); seals(); }
  function boot() {
    d.documentElement.classList.add('ps-k-on');
    scan();
    if (window.MutationObserver) new MutationObserver(function () { clearTimeout(boot.t); boot.t = setTimeout(scan, 150); }).observe(d.body, { childList: true, subtree: true });
  }
  d.readyState !== 'loading' ? boot() : d.addEventListener('DOMContentLoaded', boot);
})();
